<div  *ngIf="isSubmitting">Loading...</div>
<div>{{errorMsg}}</div>